export const SET_SEARCH = 'SET_SEARCH';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';

export const TOGGLE_LOADING = 'TOGGLE_LOADING';

export const SHOW_MODAL_SEARCH = 'SHOW_MODAL_SEARCH';

export const SAVE_SEARCH_SUCCESS = 'SAVE_SEARCH_SUCCESS';
export const SAVE_SEARCH_FAILURE = 'SAVE_SEARCH_FAILURE';

export const DELETE_SEARCH_SUCCESS = 'DELETE_SEARCH_SUCCESS';
export const DELETE_SEARCH_FAILURE = 'DELETE_SEARCH_FAILURE';

export const FETCH_SAVED_SEARCH_SUCCESS = 'FETCH_SAVED_SEARCH_SUCCESS';
export const FETCH_SAVED_SEARCH_FAILURE = 'FETCH_SAVED_SEARCH_FAILURE';

export const SEARCH_RESULTS_SUCCESS = 'SEARCH_RESULTS_SUCCESS';
